<template>
    <div>
        <top-navbar></top-navbar>
<div>
 

<div class="container-fluid">
    <h6  class="manage-boder pt-2 font1 font-bold1"> <router-link class="decoration" to="/admin/overview"> Home </router-link><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span><router-link class="decoration" to="/aparment/index"> Apartment List </router-link><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span><router-link class="decoration" :to="'/aparment/view?id='+customer_contact.id_customer"> {{ customer_contact.appartment_no}} </router-link><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span> Update Contact  </h6>
    <h6 class="custom-maintitle mb-2"><b>Update Owner Contact:{{ customer_contact.name }}</b></h6>
<div class="card ">
<div class="card-body">
  <form @submit.prevent="SaveCrm()" >







    <div class="row">
        <div class="col-md-3">
    <div class="form-group required">
            <label class="custom-label " style="font-size: small;">Homeowner</label>
            <input  v-model="customer_contact.C_name" style="font-size: small;" class="form-control" required disabled>
    </div>
  </div>
  <div class="col-md-3">
    <div class="form-group required">
            <label class="custom-label" style="font-size: small;">Name</label>
            <input  v-model="customer_contact.name" style="font-size: small;" class="form-control" required>
    
    </div>
  </div>
  <div class="col-md-3">
    <div class="form-group ">
            <label class="custom-label" style="font-size: small;">Email</label>
            <input  v-model="customer_contact.email" style="font-size: small;" class="form-control" >
    </div>
  </div>
  <div class="col-md-3">
    <div class="form-group ">
            <label class="custom-label" style="font-size: small;">Tel</label>
            <input  v-model="customer_contact.tel" style="font-size: small;" class="form-control" >
    </div>
  </div>
 
  
  

</div>






  
   

    <div style="border-bottom: 0px; padding-top: 0px;" class="navbar">
    
    <div class="d-flex  ">
    
    </div>
    <div class="d-flex  ">
      <button :disabled="isButtonDisabled" type="submit" class="mr-1 btn custom-btn btn-primary  mb-5 font-size_def">Update</button>
    </div>
    </div>



</form>
</div>
</div>
</div>









</div>






        
        <content-footer></content-footer>
    </div>
</template>
<script>
 import axios from 'axios';
 import authService from '@/auth.service';
  import TopNavbar from './../../layout/TopNavbar.vue'
  import ContentFooter from './../../layout/ContentFooter.vue'

  export default {
    data() {
      return {
        access_token:authService.isLoggedIn(),
        userid:authService.isUserid(),
        'idContact':this.$route.query.id,

        customer_contact:{},
       
        isButtonDisabled: false
      
      


        
      }

    },
    mounted(){
 
      this.loadContact(this.idContact);
    },
methods : {

 

  async loadContact(id) {
    
    try {
      const { data} = await  axios.get('/mcustomer/loadcontact?id='+id,{
        headers:{
          'Authorization':'Bearer '+this.access_token,
          'Content-type': 'application/json',
         
        }
       });
       console.log(data);
       this.customer_contact = data.customer_contact;
       
      
    } catch (error) {
      console.log(error.response);
    }
  },


  async SaveCrm() {
  
    this.isButtonDisabled = true;
    
    try {
      const { data} = await  axios.post('/mcustomer/updatecontact?id='+this.idContact,{userid:this.userid,customer_contact:this.customer_contact},{
        headers:{
          'Authorization':'Bearer '+this.access_token,
          'Content-type': 'application/json',
         
        }
       });
       console.log(data);
      this.status = data.status;
       if(this.status == 200){
        this.isButtonDisabled = false;
        this.$router.push('/aparment/view?id='+this.customer_contact.id_customer);
       }
      
    } catch (error) {
      console.log(error.response);
    }
  },

      
    



  
 

  


},

    components :{
        ContentFooter,
        TopNavbar
    },
  }

</script>
<style scoped>

</style>